import React, { useRef } from "react"
import Map, { Source, Layer } from "react-map-gl"
import { MAPBOX_TOKEN, MAP_STYLE } from "../../../constants"

const layerStyle = {
  id: "lineLayer",
  type: "line",
  source: "lines",
  layout: {
    "line-join": "round",
    "line-cap": "round",
  },
  paint: {
    "line-color": "#888",
    "line-width": 8,
  },
}

const areaLayerStyle = {
  id: "arealayer",
  type: "fill",
  source: "area",
  paint: {
    "fill-color": "yellow",
    "fill-opacity": 0.3,
  },
}

export default function AddLinesMap({
  initialCenter,
  lines,
  setLines,
  activeAreaGeoJson,
}) {
  const mapRef = useRef()

  const createNewLine = (lngLat) => {
    return {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: [[lngLat.lng, lngLat.lat]],
      },
    }
  }

  const handleMapClick = (e) => {
    if (
      lines?.features?.length === 0 ||
      lines?.features[lines?.features?.length - 1]?.geometry?.coordinates
        ?.length > 1
    ) {
      setLines({
        ...lines,
        features: [...lines.features, createNewLine(e.lngLat)],
      })
    } else {
      setLines({
        ...lines,
        features: [
          ...lines.features.filter(
            (feature, index) => index !== lines.features.length - 1
          ),
          {
            type: "Feature",
            geometry: {
              type: "LineString",
              coordinates: [
                ...lines.features[lines.features.length - 1].geometry
                  .coordinates,
                [e.lngLat.lng, e.lngLat.lat],
              ],
            },
          },
        ],
      })
    }
  }

  return (
    <Map
      initialViewState={{
        latitude: initialCenter.latitude,
        longitude: initialCenter.longitude,
        zoom: 14,
      }}
      mapStyle={MAP_STYLE}
      mapboxAccessToken={MAPBOX_TOKEN}
      style={{ width: "100%", height: "calc(100vh - 200px)" }}
      ref={mapRef}
      onClick={handleMapClick}
      interactiveLayerIds={["lineLayer"]}
    >
      <Source id="lines" type="geojson" data={lines}>
        <Layer {...layerStyle} />
      </Source>
      <Source id="area" type="geojson" data={activeAreaGeoJson}>
        <Layer {...areaLayerStyle} />
      </Source>
    </Map>
  )
}
